import { render, staticRenderFns } from "./MembersCreate.vue?vue&type=template&id=13c0d738"
import script from "./MembersCreate.vue?vue&type=script&lang=js"
export * from "./MembersCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports